import { addGenericMessage } from "@asurion-core/expert-workspace-timeline";
import { type QuickRebuttal } from "@expert/contentful";
import { useProductOfferStore, useSalesContext } from "@expert/sales-tools";
import { useCallback, useRef } from "react";

import { setSelectedTab } from "@/panels/modules/panels/store/panels.store.selectors";
import { formatQuickRebuttal } from "@/sales-tools/product-sale-flow/useProductSaleFlow.helpers";

export const useProductSaleFlow = () => {
    const { sessionId } = useSalesContext();
    // Mirror the latest sessionId into a ref so callbacks stored on the panels config
    // (which dedupes via stringify and drops function refs) read the current value at
    // call time instead of going stale across chat switches.
    const sessionIdRef = useRef(sessionId);
    sessionIdRef.current = sessionId;
    const selectedProduct = useProductOfferStore((state) => state.getSelectedProduct(sessionId));

    const selectedProductInfo = selectedProduct?.productSku
        ? useProductOfferStore.getState().getProductInfo(sessionId, selectedProduct.productSku)
        : undefined;
    const productSaleFlowPanelTitle = selectedProductInfo?.displayName ?? "Product Sale";

    const handleProductSaleClose = useCallback(() => {
        useProductOfferStore.getState().updateSelectedProduct(sessionIdRef.current, undefined);
    }, []);

    const addQuickRebuttalToExpertAssistTimeline = (quickRebuttal?: QuickRebuttal) => {
        addGenericMessage(sessionId, formatQuickRebuttal(quickRebuttal));
        setSelectedTab("rightBottom")("a");
    };

    return {
        handleProductSaleClose,
        addQuickRebuttalToExpertAssistTimeline,
        productSaleFlowPanelTitle,
        selectedProduct,
        selectedProductInfo,
    };
};
